import { render, staticRenderFns } from "./VoiceWaveIcon.vue?vue&type=template&id=944b7c48&"
import script from "./VoiceWaveIcon.vue?vue&type=script&lang=js&"
export * from "./VoiceWaveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports